import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/hooks/useAuth';
import { useFlags } from '@/hooks/useFlags';

import { getSystemPlans1Options } from '@/_generated/api-clients/xp';

/**
 * Shared hook to fetch system plans (templates).
 * Used by ManagePlansTab, ReportsPlansTab, and ChooseTemplate to share
 * the TanStack Query cache and provide systemPlans for computing isReadonlySubscribed.
 */
const useSystemPlans = () => {
  const { xpCompliancePlans: inHouseCompliancePlansFF } = useFlags();
  const { data } = useAuth();
  const isAtLeastLeader =
    (data?.allLocationsWithAtLeastLeaderPermissions.length ?? 0) > 0;

  const {
    data: systemPlans = [],
    isFetching: isFetchingSystemPlans,
    isPending: isPendingSystemPlans,
    error: systemPlansError,
  } = useQuery({
    ...getSystemPlans1Options(),
    enabled: isAtLeastLeader,
    select: data =>
      inHouseCompliancePlansFF
        ? data
        : data.filter(plan => plan.type !== 'COMPLIANCE'),
  });

  return {
    systemPlans,
    isFetchingSystemPlans,
    isPendingSystemPlans,
    systemPlansError,
  };
};

export default useSystemPlans;
